export const ENDPOINTS = {
  currentUser: () => '/shelf/current_user',

  planograms: () => '/shelf/planograms',
  planogramsIndex: () => '/shelf/planograms/index',
  planogram: (planogramId: number) => `/shelf/planograms/${planogramId}`,

  planogramVersion: (planogramId: number, versionId: number) =>
    `/shelf/planograms/${planogramId}/versions/${versionId}`,
  planogramAssemblyManualImage: (planogramId: number, versionId: number, segmentId: number) =>
    `/shelf/planograms/${planogramId}/versions/${versionId}/segments/${segmentId}/assembly_manual_image`,

  productsIndex: () => '/shelf/products/index',

  columnSettings: () => '/shelf/column_settings',
  columnSettingsIndex: () => '/shelf/column_settings/index',
} as const;
